import React, { useState } from 'react';
import { Toolbar, Grid, Stack, Button, IconButton, Paper } from "@mui/material";
import ReplayIcon from '@mui/icons-material/Replay';
import AddIcon from '@mui/icons-material/Add';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import { useNavigate } from "react-router-dom";
import { useFormik } from 'formik';
import get from "lodash/get";
import { useSelector } from "react-redux";
import { exportToExcel } from "react-json-to-excel";
import { useCanView } from "../../../config/hook/UserPermissions";
import Alert from "../../../components/form/Alert";
import InputText from "../../../components/form/InputText";

const ToolbarComponent = ({ setFilter, __, reload, isLoading }) => {
    const canView = useCanView();
    const navigate = useNavigate();
    const billingCode = useSelector(state => state.masters.billingCode);
    const [alert, setAlert] = useState({ open: false, title: "", subtitle: "", type: "" });

    const onSubmit = (values) => {
        let Filters = "";
        if (!!values.codFactura) { Filters = `COD_FACTURA@=${values.codFactura}` }
        if (!!values.description) { Filters = `${!!Filters ? `${Filters},` : ""}Description@=${values.description}` }
        switch (get(values, "isActive")) {
            case 1: { Filters = `${!!Filters ? `${Filters},` : ""}isActive==true` }; break;
            case 2: { Filters = `${!!Filters ? `${Filters},` : ""}isActive==false` }; break;
            default: break;
        }
        setFilter(Filters)
    }

    const isActive = [
        { value: 0, name: __(`isActive.all`) },
        { value: 1, name: __(`isActive.true`) },
        { value: 2, name: __(`isActive.false`) },
    ]

    const formik = useFormik({
        initialValues: {
            codFactura: "",
            description: "",
            isActive: get(isActive, "[0].value"),
        },
        onSubmit,
    });

    const closeAlert = () => {
        setAlert({ open: false, title: "", subtitle: "", type: "", btn: "" });
    }

    return (
        <Toolbar component={Paper} className='p-2 mb-4' sx={{ borderBottomWidth: "1px", borderBottomColor: "text.sslite", borderBottomStyle: "solid", position: "sticky", top: 0, zIndex: 100 }}>
            <Stack component="form" onSubmit={get(formik, "handleSubmit")} direction={{ sx: "column", xl: "row" }} alignItems={{ sx: "flex-start", xl: "center" }} justifyContent={{ sx: "center", xl: "space-between" }} spacing={{ sx: 1, xl: 1 }} className='w-full'>
                <Grid container spacing={1} justifyContent={{ sx: "flex-start", md: "flex-end" }}>
                    <Grid item xs={12} md={4} lg={3} xl={2}>
                        <Stack direction="row" spacing={1} justifyContent="flex-end">
                            <Button
                                className='w-[100px] min-w-[100px]'
                                startIcon={<AddIcon />}
                                variant="contained"
                                color="secondary"
                                onClick={() => {
                                    if (canView("CONFIGURACIÓN/CODIGOS FACTURACION", "add")) {
                                        navigate("new");
                                    } else {
                                        setAlert({
                                            open: true,
                                            title: "Permiso Denegado.",
                                            subtitle: (<ul> • No tienes permiso para crear un nuevo código de facturación.</ul>),
                                            type: "error",
                                            func: closeAlert
                                        });
                                    }
                                }}
                            >
                                {__(`toolbar.btn`)}
                            </Button>
                        </Stack>
                    </Grid>
                    <Grid item xs="auto" justifyContent="flex-end" display="flex">
                        <Button
                            variant="contained"
                            color="success"
                            startIcon={<SaveAltIcon />}
                            onClick={() => exportToExcel(billingCode.data?.data, 'Codigos Facturacion')}
                            disabled={!billingCode?.data?.data || billingCode.data.data.length === 0}
                        >
                            Exportar
                        </Button>
                        <IconButton title={__(`toolbar.reload`)} onClick={reload}>
                            <ReplayIcon sx={{ transform: "scaleX(-1) rotate(-45deg)" }} />
                        </IconButton>
                    </Grid>
                </Grid>
                <Alert
                    title={get(alert, "title")}
                    subtitle={get(alert, "subtitle")}
                    btn1={{ func: get(alert, "func") }}
                    btn2={{}}
                    type={get(alert, "type")}
                    openAlert={get(alert, "open")}
                    closeAlert={closeAlert}
                />
            </Stack>
        </Toolbar>
    )
}

export default ToolbarComponent
